import FullCalendar from './components/FullCalendar.vue'

export default {
    install: function (Vue, options) {
        Vue.component('full-calendar', FullCalendar);
    },
}
export { FullCalendar }



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-full-calendar/index.js
// module id = 977
// module chunks = 170